DialogInformesCompartirCtrl.$inject = ['$log', '$scope', '$http', '$q'];
export default function DialogInformesCompartirCtrl($log, $scope, $http, $q) {
    var vm = this;

    vm.model = $scope.model;
    vm.dialogHandler = $scope.dialog;
    vm.cargando = {
        datos: true,
        submit: false
    };

    var urlBase = Sigo.url + '/api/v1/informes';

    vm.formDeshabilitado = true;
    vm.modoEdicion = false;
    vm.reparadores = null;

    vm.usuarios = [];
    vm.usuariosRestantes = [];

    init();

    function init() {
        var promesas = [];
        promesas.push(cargarInforme(vm.model.informeId));
        promesas.push(cargarUsuarios(vm.model.informeId));
        promesas.push(cargarUsuariosRestantes(vm.model.informeId));
        $q.all(promesas).then(function () {
            vm.formDeshabilitado = false;
            vm.cargando.datos = false;
        });
    }

    function cargarInforme(informeId) {
        var url = urlBase + '/' + informeId + '?include=usuario';
        var promesa = $http.get(url);
        promesa.then(function (respuesta) {
            vm.informe = respuesta.data;
        });
        return promesa;
    }

    function cargarUsuarios(informeId) {
        var url = urlBase + '/' + informeId + '/usuarios';
        var promesa = $http.get(url);
        promesa.then(function (respuesta) {
            vm.usuarios = respuesta.data;
        }, function (err) {
            $log.error('Error');
        });
        return promesa;
    }

    function cargarUsuariosRestantes(informeId) {
        var url = urlBase + '/' + informeId + '/usuarios-restantes';
        var promesa = $http.get(url);
        promesa.then(function (respuesta) {
            vm.usuariosRestantes = respuesta.data;
        }, function (err) {
            $log.error('Error');
        });
        return promesa;
    }

    vm.renderUsuario = function (usuario) {
        return usuario.codusuario + ' (' + usuario.nombre + ' ' + usuario.apellidos + ')';
    };

    vm.anyadirUsuario = anyadirUsuario;

    function anyadirUsuario(usuario, informeId) {
        vm.formDeshabilitado = true;
        vm.cargando.submit = true;
        var url = urlBase + '/' + informeId + '/usuarios';
        var data = {usuario_id: usuario.id};
        var promesa = $http.post(url, data);
        promesa.then(function (respuesta) {
            vm.usuarios = respuesta.data;
            vm.usuariosRestantes = vm.usuariosRestantes.filter(function (item) {
                return item.id != usuario.id;
            });
            vm.usuario = null;
            vm.formDeshabilitado = false;
            vm.cargando.submit = false;
        }, function (err) {
            $log.error('Error');
            vm.formDeshabilitado = false;
            vm.cargando.submit = false;
        });
        return promesa;
    }

    vm.eliminarUsuario = eliminarUsuario;

    function eliminarUsuario(usuario, informeId) {
        vm.formDeshabilitado = true;
        vm.cargando.submit = true;
        var url = urlBase + '/' + informeId + '/usuarios/' + usuario.id;
        var promesa = $http.delete(url);
        promesa.then(function (respuesta) {
            vm.usuarios = respuesta.data;
            vm.formDeshabilitado = false;
            vm.cargando.submit = false;
            vm.usuariosRestantes.push(usuario);
        }, function (err) {
            $log.error('Error');
            vm.formDeshabilitado = false;
            vm.cargando.submit = false;
        });
        return promesa;
    }

    vm.cerrar = function () {
        vm.dialogHandler.cancel();
    }

}